import { SITE_URL, toAbsoluteUrl } from './constants'

export type BreadcrumbInput = { label: string; link?: string }

export const buildBreadcrumbListSchema = (items: BreadcrumbInput[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items
    .filter((it) => !!it?.label)
    .map((it, i) => {
      const position = i + 1
      const entry: Record<string, any> = {
        '@type': 'ListItem',
        position,
        name: it.label,
      }
      if (it.link) entry.item = toAbsoluteUrl(it.link)
      else if (i === 0) entry.item = SITE_URL
      return entry
    }),
})
